import { api } from './index.js';
import { PROJECT_MODE } from '@utils/constants.js';
const { SINGLE_IMAGE, ORTHOPHOTO } = PROJECT_MODE;

const convertBytesToMegabytes = bytes => (bytes / 1024 ** 2).toFixed(0);
export const startPostProcessing = async ({
	projectUuid,
	projectMode,
	advancedOptions = {},

	// File Info
	fileCount,
	exifData,
	tifSize,
	isTif,
}) => {
	const tifSizeMB = convertBytesToMegabytes(tifSize);
	const singleImageEndpoint = `/biodroneai/singleimage_processing/${projectUuid}`;
	const photogrammetryEndpoint = `/photogrammetry/process/${projectUuid}/${fileCount}`;
	const orthophotoEndpoint = `/photogrammetry/process-orthophoto/${projectUuid}/${tifSizeMB}`;

	const { predict_requests, processing_preset, view3d } = advancedOptions;

	let body = { predict_requests };
	let url = '';

	if (projectMode == SINGLE_IMAGE) {
		url = singleImageEndpoint;
		body.exifdata = exifData;
	}

	if (projectMode == ORTHOPHOTO) {
		if (isTif) url = orthophotoEndpoint;
		else {
			url = photogrammetryEndpoint;
			body.processing_preset = processing_preset;
			if (view3d) body.view3d = view3d;
		}
	}

	await api.post(url, body);

	return true;
};

/** Runs object detection within the provided polygon */
export const detectObjects = async ({ projectUuid, modelUuid, polygon, useSam = true }) => {
	try {
		const result = await api.post('/biodroneai/predict-in-polygon', {
			project_uuid: projectUuid,
			model_uuid: modelUuid,
			polygon,
			use_sam: useSam,
		});

		const { data } = result ?? {};
		if (data?.results_file) return data;
		else throw new Error('No results file');
	} catch (err) {
		throw err;
	}
};
